// extracted by mini-css-extract-plugin
module.exports = {"employeesTable":"_1v-Sd6rj","employeeFilters":"Oq8mVblV","newEmployeeButton":"brJSIpHx","employeesMainContent":"_3kJ_vLEd","employeesHeader":"_2Gc7ig0E","employeesHeaderText":"_2LAlplsm","employeesText":"_2hsDzO4n","checkbox":"guH5BDik"};
    if(module.hot) {
      // 1746735766205
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  